import { fromJS } from 'immutable';
import moment from 'moment';

import mergeWithArray from '../../helpers/mergeWithArray';
import * as actionTypes from './actionTypes';

const initialBrokerageOfferDetails = {
  brokerageOtherClosingCostsCents: 0,
  hoaTransferFeeCents: 0,
  mortgagePayoffCents: 0,
  odAvgNumShowings: 10,
  odEstDaysBuyer: 50,
  showSubFields: false,
};

export const initialState = fromJS({
  brokerageOfferData: {
    offerDetails: initialBrokerageOfferDetails,
  },
  invitationData: null,
  invitationToken: null,
  isBrokerageOfferDataLoading: true,
  isNewOfferRequested: false, // TODO: should we load this value from the server?
  isShowingAcceptModal: false,
  otherBids: null,
});

interface IAction {
  type: string;
  payload?: any;
  error?: boolean;
}

export default function reducer(state = initialState, action: IAction) {
  switch (action.type) {
    case actionTypes.BEGIN_LOADING_BROKERAGE_OFFER_DATA:
      return state.merge({
        isBrokerageOfferDataLoading: true,
      });
    case actionTypes.RECEIVE_BROKERAGE_OFFER_DATA:
      const payloadData = action.payload.brokerageOfferData;
      // fallback to brokerage offer if no OD offer
      const odOfferHeadlineCents =
        payloadData['od_offer']['headline_cents'] || payloadData['price_cents'];

      const brokerageOfferData = {
        ...payloadData,
        offerDetails: {
          brokerageBrokerFees: {
            percent: payloadData['broker_fee'] * 100,
            value: payloadData['broker_fee'] * payloadData['price_cents'],
          },
          brokerageOfferExpirationDate: moment(payloadData['expires_at']).format('dddd, MMMM Do'),
          odBrokerFees: {
            percent: 6,
            value: 6 * odOfferHeadlineCents * 0.01,
          },
          odHomeOwnership: {
            percent: 1,
            value: 1 * odOfferHeadlineCents * 0.01,
          },
          odOfferHeadlineCents,
          odSellerConcessions: {
            percent: 2,
            value: 2 * odOfferHeadlineCents * 0.01,
          },
          streetAddress: payloadData['address'] && payloadData['address']['street1'],
          titleInsuranceEscrowNotaryCents: payloadData['title_insurance_escrow_notary_cents'],
        },
      };

      return state.mergeDeep({
        brokerageOfferData,
        isBrokerageOfferDataLoading: false,
      });
    case actionTypes.RECEIVE_OTHER_BIDS_DATA:
      return state.merge({
        otherBids: action.payload.otherBidsData,
      });
    case actionTypes.RECEIVE_INVITATION_DATA:
      return state.merge({
        invitationData: action.payload.invitationData,
      });
    case actionTypes.UPDATE_BROKERAGE_OFFER_DETAILS:
      return state.mergeDeep({
        brokerageOfferData: {
          offerDetails: {
            ...action.payload,
          },
        },
      });
    case actionTypes.UPDATE_PURCHASE_AGREEMENT:
      return state.mergeWith(mergeWithArray, {
        purchaseAgreement: {
          ...action.payload,
        },
      });
    case actionTypes.SET_INVITATION_TOKEN:
      return state.merge({
        invitationToken: action.payload.invitationToken,
      });
    case actionTypes.SHOW_DECLINE_OFFER_MODAL:
      return state.merge({
        isShowingDeclineModal: true,
      });
    case actionTypes.HIDE_DECLINE_OFFER_MODAL:
      return state.merge({
        isShowingDeclineModal: false,
      });
    case actionTypes.HANDLE_RETURNING_USER:
    case actionTypes.BEGIN_OFFER_ACCEPT:
      return state.merge({
        loginError: null,
      });
    case actionTypes.SET_NEW_OFFER_REQUESTED:
      return state.merge({
        isNewOfferRequested: true,
      });
    case actionTypes.LOGIN_ERROR:
      return state.merge({
        loginError: action.payload.errorMsg,
      });
    default:
      return state;
  }
}
